import { render, staticRenderFns } from "./BookingAdditionalChargeSummary.vue?vue&type=template&id=0b45abc9&"
import script from "./BookingAdditionalChargeSummary.vue?vue&type=script&lang=js&"
export * from "./BookingAdditionalChargeSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingAdditionalChargeSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports